import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { ApiService } from '@core/http/api.service';
import type { UpdateUserPreferencesPayload, UserPreferences } from './user-preferences.types';

/**
 * Client HTTP pour les préférences scalaires du staff admin.
 *
 * Endpoints :
 *   GET   /me/preferences  → UserPreferences
 *   PATCH /me/preferences  (Partial) → UserPreferences
 */
@Injectable({ providedIn: 'root' })
export class UserPreferencesApiService {
  private readonly api = inject(ApiService);

  getMyPreferences(): Observable<UserPreferences> {
    return this.api.get<UserPreferences>('/me/preferences');
  }

  updatePreferences(payload: UpdateUserPreferencesPayload): Observable<UserPreferences> {
    return this.api.patch<UserPreferences>('/me/preferences', payload);
  }
}
